module.exports = __webpack_public_path__ + "img-front/register/kinesis-first.d02a72ac.svg";